const serviceRoot =
  'https://services.arcgis.com/P3ePLMYs2RVChkJx/arcgis/rest/services/USA_Census_Counties/FeatureServer/0/';

export const ArcGisEndpoints = {
  getCountyListByState: () => `${serviceRoot}query`,
};
